export const promiseConfiguration = () =>
  fetch('/api/configuration').then(resp => resp.json())
